import React from 'react';
import { Button } from '@mui/material';
// eslint-disable-next-line no-unused-vars
import IButton from '../types/IButton';

const ButtonComponent = ({ title, disabled, onClick = () => { } }: IButton) => {

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        onClick(e);
    };

    return (

            <Button className="ituBtn" disabled={disabled} disableRipple disableFocusRipple disableTouchRipple onClick={(e) => handleClick(e)}>{title}</Button>

    );
}
export default ButtonComponent;